<div id="openExtendsGroupGuideProjection" class="modal fade in" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title mt-0 text-danger bold" id="mySmallModalLabel">GRÁFICO HISTÓRICO</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <app-loading-modal></app-loading-modal>
      <div class="modal-body">
        <div class="card m-b-30">
          <div class="row justify-content-md-center">
            <div class="col-lg-4">
              <div class="content__subhead__inputGrid m-r-5">
                <div class="input-group" style="width: auto;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt m-r-5"></i> Seleccionar fecha
                    </span>
                  </span>
                  <input type="text" id="date_range_projection" class="form-control content__subhead__inputGrid__input" readonly>
                </div>
              </div>
            </div>
            <div class="col-12 m-t-25">
              <highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" (chartInstance)="onChartInstance($event)"
                style="width: 100%; height: 400px; display: block;">
              </highcharts-chart>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary waves-effect" data-dismiss="modal"
          (click)="close()">Cerrar</button>
      </div>
    </div>
  </div>
</div>